import axios from "axios";
async function createPaymentLink(body) {
    return new Promise((resolve, reject) => {
        axios.post(process.env.REACT_APP_PAYMENT_LINK_URL+'payments/create-payment-link-new',body).then((resp) => {
          resolve(resp.data);
        }).catch((err) => {
          reject(err);
        });
      });
}
async function resendPaymentLink(body) {
    return new Promise((resolve, reject) => {
        axios.post(process.env.REACT_APP_PAYMENT_LINK_URL+'payments/resend-payment-link',body).then((resp) => {
          resolve(resp.data);
        }).catch((err) => {
          reject(err);
        });
      });
}
async function createVirtualAccount(body) {
  return new Promise((resolve, reject) => {
    axios
      .post(
        process.env.REACT_APP_PAYMENT_LINK_URL + "payments/create-virtual-acc",
        body
      )
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

async function closeVirtualAccount(body) {
  return new Promise((resolve, reject) => {
    axios
      .post(
        process.env.REACT_APP_CLOSED_VIRTUAL_ACCOUNT_URL + "payments/closedVirtualAccount",
        body
      )
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

async function getVirtualAccountStatus(body) {
  return new Promise((resolve, reject) => {
    axios
      .post(
        process.env.REACT_APP_PAYMENT_LINK_URL + "payments/getVirtualAccStatus",
        body
      )
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

async function recreateVirtualAccount(body) {
  return new Promise((resolve, reject) => {
    axios
      .post(
        process.env.REACT_APP_PAYMENT_LINK_URL + "payments/recreateVirtualAcc",
        body
      )
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject(err);
      });
    });
}
async function refundTokenPayment(body) {
  return new Promise((resolve, reject) => {
    // process.env.REACT_APP_PAYMENT_LINK_URL
    // 'http://192.168.2.113:8000/'
      axios.post(process.env.REACT_APP_PAYMENT_LINK_URL+'payments/refund',body).then((resp) => {
        resolve(resp);
      }).catch((err) => {
        reject(err);
      });
    });
}
async function refundFromAllAllotmentPayment(body) {
  return new Promise((resolve, reject) => {
    // process.env.REACT_APP_PAYMENT_LINK_URL
    // 'http://192.168.2.113:8000/'
      axios.post(process.env.REACT_APP_PAYMENT_LINK_URL+'payments/refundAllTransactions',body).then((resp) => {
        resolve(resp);
      }).catch((err) => {
        reject(err);
      });
    });
}
async function bucketingForChangeUnit(body) {
  return new Promise((resolve, reject) => {
    // process.env.REACT_APP_PAYMENT_LINK_URL
    // 'http://192.168.2.113:8000/'
      axios.post(process.env.REACT_APP_PAYMENT_LINK_URL+'payments/applyBucketing',body).then((resp) => {
        resolve(resp);
      }).catch((err) => {
        reject(err);
      });
    });
}
async function moveToChangeAVViaApi(body) {
  return new Promise((resolve, reject) => {
    axios.post(process.env.REACT_APP_PAYMENT_LINK_URL+'changeAv/move-to-change-av',body).then((resp) => {
      resolve(resp);
    }).catch((err) => {
      reject(err);
    });
  });
}
// Parking-upgrade approval. Runs the approval writes server-side so the RNL
// feedback-form link can be triggered with the API key held on the backend.
// Only used when the CRM row carries a parking upgrade cost — every other AV
// approval still goes through the existing in-modal path.
async function approveParkingUpgradeViaApi(body) {
  return new Promise((resolve, reject) => {
    axios.post(process.env.REACT_APP_PAYMENT_LINK_URL+'changeAv/approve-parking-upgrade',body).then((resp) => {
      resolve(resp);
    }).catch((err) => {
      reject(err);
    });
  });
}
export {createPaymentLink,resendPaymentLink,createVirtualAccount,refundTokenPayment,bucketingForChangeUnit,refundFromAllAllotmentPayment,
  getVirtualAccountStatus,
  recreateVirtualAccount,
  closeVirtualAccount,
  moveToChangeAVViaApi,
  approveParkingUpgradeViaApi,}